import Vue from "vue";

Vue.component("wto-chart", {
	props: ["loading", "hasData", "chartOptions", "footer"],
	computed: {
		loadingText() {
			return window.labels.loading;
		}
	},
	template: `
	    <div>
	        <div v-if="loading" class="loading-chart" style="height: 400px;background: #edf3ff;display: table;width: 100%;">
				<loading style="display: table-cell; vertical-align: middle; text-align: center;" :loading-text="loadingText"></loading>
	        </div>
	        <div v-else>
	            <div v-if="hasData">
	                <div class="bg-blue-lighter" id="chart">
	                    <highcharts :options="chartOptions" style="width: inherit"></highcharts>
	                </div>
	                <p class="text-muted mt-3" v-html="footer"></p>
	            </div>

	            <div v-else class="bg-blue-lighter d-flex justify-content-center align-items-center" style="height: 400px;">
	                No available data for {{ chartOptions.title.text }} chart
	            </div>
	        </div>
	    </div>
	`
});